// src/routes/PageRender.jsx

import About from "../../pages/AboutPage/page/About";
import AboutLanding from "../../pages/AboutPage/page/AboutLanding";
import AboutMilestone from "../../pages/AboutPage/page/AboutMilestone";
import AboutPartner from "../../pages/AboutPage/page/AboutPartner";
import CareerLanding from "../../pages/CareerPage/page/CareerLanding";

import Franchise from "../../pages/FranchisePage/page/Franchise";
import GeneralPage from "../../pages/GeneralPage/Page/generalPage";
import InstitutionPage from "../../pages/InstitutionPage/page/InstitutionPage";



const PAGE_TYPE_COMPONENT = {
  4: GeneralPage,
  7: InstitutionPage,
 
  8: AboutLanding, //who we are
  13: AboutMilestone,
  9: AboutPartner, //partnership
  10: About, //ceo
  11: CareerLanding, //career
  12: Franchise,
};

const ThemeRenderer = ({ pageData }) => {
  console.log("Resolved page:", pageData);

  const Component = PAGE_TYPE_COMPONENT[pageData?.pageType] || GeneralPage;

  return <Component pageData={pageData} />;
};

export default ThemeRenderer;
